<template>
  <div>
    <v-dialog v-model="visible" persistent :max-width="'80%'">
      <v-card v-if="itemDetail">
        <v-card-title>{{ title }}</v-card-title>
        <v-card-text>
          <v-tabs class="mb-2" v-model="tab" :color="Theme.GREEN">
            <v-tab :value="0">會員基本資料</v-tab>
            <v-tab :value="1">會員訂單資料</v-tab>
            <v-tab :value="2">賞品盒</v-tab>
            <v-tab :value="3">消費紀錄</v-tab>
          </v-tabs>
          <div v-if="tab === 0">
            <v-layout v-for="col in getDialogKeys" :key="col.value">
              <v-flex xs12 md6>
                <div v-if="col.tag">
                  <label class="subtitle-2">{{ `${col.text} : ` }}</label>
                  <v-chip
                    :dark="getSelectColor(col, itemDetail) !== Theme.LIGHT_GRAY"
                    :color="getSelectColor(col, itemDetail)"
                    >{{ getSelectList(col, itemDetail) }}</v-chip
                  >
                </div>

                <!-- 手機跟信箱已驗證 > 顯示文字 -->
                <div
                  v-else-if="
                    (col.value === 'verifyEmail' ||
                      col.value === 'verifyPhone') &&
                    itemDetail[col.value] === true
                  "
                >
                  <label class="subtitle-1" style="color: black">{{
                    `${col.text} : `
                  }}</label>
                  <span class="subtitle-1" style="color: green">已驗證</span>
                </div>

                <!-- 手機跟信箱未驗證 > 顯示下拉選單 -->
                <v-select
                  v-else-if="
                    (col.value === 'verifyEmail' ||
                      col.value === 'verifyPhone') &&
                    itemDetail[col.value] !== true
                  "
                  :color="Theme.GREEN"
                  :items="col.options"
                  :label="col.text"
                  item-text="value"
                  item-value="key"
                  v-model="itemDetail[col.value]"
                />

                <v-select
                  v-else-if="col.options"
                  :color="Theme.GREEN"
                  :items="col.options"
                  :label="col.text"
                  item-text="value"
                  item-value="key"
                  v-model="itemDetail[col.value]"
                />

                <div v-else-if="col.disable">
                  <label class="subtitle-1" style="color: black">{{
                    `${col.text} : `
                  }}</label>
                  <span class="subtitle-1" :style="{ color: Theme.GREEN }">{{
                    itemDetail[col.value]
                  }}</span>
                </div>

                <div
                  class="col-sm-12"
                  v-else-if="
                    col.value === 'birthday' || col.value === 'vendorDate'
                  "
                >
                  <date-picker
                    :date="itemDetail.birthday"
                    @updateDate="changeBirthday"
                    :date-string="col.text"
                  />
                </div>

                <v-textarea
                  v-else-if="col.value === 'comment'"
                  :label="col.text"
                  :color="Theme.GREEN"
                  v-model="itemDetail[col.value]"
                />

                <!-- 如果 col.value 為 'vendorLevel'，則顯示只能輸入數字的輸入框 -->
                <v-text-field
                  v-else-if="col.value === 'vendorLevel'"
                  type="number"
                  :label="col.text"
                  v-model="itemDetail[col.value]"
                  :disabled="col.disable"
                  :color="Theme.GREEN"
                ></v-text-field>

                <v-text-field
                  v-else
                  v-model="itemDetail[col.value]"
                  :label="col.text"
                  :disabled="col.disable"
                  :color="Theme.GREEN"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </div>
          <v-layout class="mt-2" v-if="tab === 1" row>
            <v-flex>
              <table-view
                :items="list"
                :columnKeys="getColumnKeys"
                :pagination="pagination"
                :loading="loading"
              />
            </v-flex>
          </v-layout>
          <v-layout class="mt-2" v-if="tab === 2" row>
            <!-- 賞品盒查詢 -->
            <v-layout row wrap align-center class="px-6 mb-2">
              <v-flex xs12 md6>
                <v-text-field
                  v-model="prizeSearchKeyword"
                  label="搜尋賞品"
                  append-icon="mdi-magnify"
                  :color="Theme.GREEN"
                  @keyup.enter="loadUserPrizeList"
                ></v-text-field>
              </v-flex>
              <v-flex>
                <v-btn
                  :color="Theme.GREEN"
                  class="white--text ml-3"
                  @click="loadUserPrizeList"
                >
                  搜尋
                </v-btn>
                <v-btn
                  color="grey"
                  class="white--text ml-3"
                  @click="clearPrizeSearch"
                >
                  清除
                </v-btn>
              </v-flex>
            </v-layout>

            <table-view
              :items="prizeList"
              :columnKeys="getPrizeKeys"
              :pagination="pagination"
              :loading="loading"
              @cellEvent="handleCellEvent"
            />
          </v-layout>

          <!-- 查詢消費紀錄，需有搜尋及分頁，且要顯示查詢區間內總額 -->
          <div v-if="tab === 3">
            <!-- 搜尋區域 -->
            <v-card class="mb-4">
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="4">
                    <v-menu
                      v-model="startDateMenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="searchStartDate"
                          label="開始日期"
                          prepend-icon="mdi-calendar"
                          readonly
                          :color="Theme.GREEN"
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="searchStartDate"
                        :color="Theme.GREEN"
                        no-title
                        @input="startDateMenu = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-menu
                      v-model="endDateMenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="searchEndDate"
                          label="結束日期"
                          prepend-icon="mdi-calendar"
                          readonly
                          :color="Theme.GREEN"
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="searchEndDate"
                        :color="Theme.GREEN"
                        no-title
                        @input="endDateMenu = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="searchConsumeItem"
                      label="廠商名稱"
                      :color="Theme.GREEN"
                      clearable
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-btn
                      :color="Theme.GREEN"
                      dark
                      @click="loadUserConsumeData"
                      class="mr-2"
                    >
                      搜尋
                    </v-btn>
                    <v-btn :color="Theme.PINK" dark @click="resetSearch">
                      重置
                    </v-btn>
                    <v-spacer></v-spacer>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

            <!--  v-if="totalAmount > 0" -->
            <span class="subtitle-1">
              查詢區間內消費總額：<strong :style="{ color: Theme.GREEN }">{{
                totalAmount.toLocaleString()
              }}</strong>
            </span>

            <!-- 資料表格 -->
            <table-view
              :items="list"
              :columnKeys="getConsumeKeys"
              :pagination="pagination"
              :loading="loading"
              @changePage="changeConsumePage"
            />
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn v-if="showCancel" :color="Theme.PINK" dark @click="cancelEvent"
            >取消</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            dark
            :color="Theme.GREEN"
            :loading="saveLoading"
            @click="confirmEvent"
            >確定</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 編輯體積彈窗 -->
    <v-dialog v-model="weightDialog" max-width="400px" persistent>
      <v-card>
        <v-card-title>編輯體積</v-card-title>
        <v-card-text>
          <v-text-field
            v-model="editingWeight"
            label="體積"
            type="number"
            :color="Theme.GREEN"
            placeholder="請輸入數字格式的體積"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :color="Theme.PINK" dark @click="cancelEditWeight">取消</v-btn>
          <v-btn
            :color="Theme.GREEN"
            dark
            @click="confirmEditWeight"
            :loading="weightSaveLoading"
            >確認</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import common from "@/mixins/common";
import DatePicker from "../../components/DatePicker";
import { mapActions } from "vuex";
import TableView from "@/components/TableView";
export default {
  name: "UserDetail",
  components: {
    DatePicker,
    TableView,
  },
  mixins: [common],
  props: {
    title: String,
    itemDetail: Object,
    visible: Boolean,
    showCancel: Boolean,
  },
  data() {
    // 取得當前日期
    const today = new Date();
    // 計算一個月前的日期
    const oneMonthAgo = new Date();
    oneMonthAgo.setMonth(today.getMonth() - 1);

    // 格式化日期為 YYYY-MM-DD 格式
    const formatDate = (date) => {
      return date.toISOString().split("T")[0];
    };

    return {
      tab: 0,
      saveLoading: false,
      list: [],
      loading: false,
      pagination: {
        page: 1,
        itemsPerPage: 10,
        totalItems: 0,
      },
      prizeList: [],
      prizeSearchKeyword: "",
      // 編輯體積相關
      weightDialog: false,
      editingWeight: "",
      editingPrizeId: null,
      weightSaveLoading: false,
      // 消費紀錄 > 搜尋相關
      search: "",
      searchConsumeItem: "賞翻天",
      searchStartDate: formatDate(oneMonthAgo), // 預設為一個月前
      searchEndDate: formatDate(today), // 預設為今天
      startDateMenu: false,
      endDateMenu: false,
      // 消費紀錄 > 總額
      totalAmount: "",
    };
  },
  watch: {
    // 'itemDetail.city'(value) {
    //   this.itemDetail.city = value;
    // },
    // 'itemDetail.district'(value) {
    //   console.log(`selectArea == ${JSON.stringify(value)}`)
    //   this.itemDetail.district = value;
    //   const find = this.areaList[this.itemDetail.city].find(a => a.text === value);
    //   if (find) {
    //     this.itemDetail.zipCode = find.zip;
    //   }
    // },
    tab(value) {
      console.log(`tab == ${JSON.stringify(value)}`);
      if (value === 1) {
        this.loadUserOrderData();
      }
      if (value === 2) {
        this.loadUserPrizeList();
      }
      if (value === 3) {
        this.loadUserConsumeData();
      }
    },
  },
  created() {
    this.loadCityData();
  },
  computed: {
    getDialogKeys() {
      let list = [
        { value: "userId", text: "會員編號", disable: true },
        {
          value: "createdDate",
          text: "註冊日期",
          sortable: true,
          disable: true,
        },
        { value: "nickname", text: "暱稱", sortable: false, disable: true },
        { value: "name", text: "姓名", sortable: false, disable: true },
        { value: "email", text: "Email", sortable: false, disable: true },
        { value: "cellphone", text: "電話", sortable: false, disable: false },
        // { value:'country', text:'國家', sortable: false, options: this.getCountryType},
        { value: "zipCode", text: "郵遞區號", sortable: false, disable: true },
        { value: "city", text: "城市", sortable: false, disable: true },
        { value: "district", text: "區域", sortable: false, disable: true },
        { value: "address", text: "收件地址", sortable: false, disable: true },
        // { value:'fullAddress', text:'收件地址', sortable: false ,disable: false},
        // { value:'birthday', text:'生日', sortable: false  },
        {
          value: "verifyEmail",
          text: "Email驗證",
          sortable: false,
          options: this.isVerifyEmail,
        },
        {
          value: "verifyPhone",
          text: "手機驗證",
          sortable: false,
          options: this.isVerifyEmail,
        },
        { value: "vendor", text: "註冊方式", disable: true },
        { value: "comment", text: "備註", disable: true },

        {
          value: "role",
          text: "角色",
          sortable: false,
          options: this.getRoleList,
        },
        { value: "vendorName", text: "商店名稱", sortable: false },
        { value: "vendorLevel", text: "廠商排序", sortable: false },
        { value: "vendorDate", text: "商店加入日期", sortable: false },
        { value: "fee", text: "手續費抽成(%)", sortable: false },
        { value: "rent", text: "維護費(月)", sortable: false },
      ];

      return list;
    },
    getColumnKeys() {
      return [
        { value: "orderId", text: "訂單編號", sortable: true },
        { value: "tempImageURL", text: "商品", sortable: true, isImage: true },
        { value: "createdDate", text: "訂購日期", sortable: true },
        { value: "count", text: "商品數量", sortable: true },
        // { value:'paymentStatus', text:'付款狀態', sortable: true , options: this.getPaymentStatus, tag: true,},
        {
          value: "shippingStatus",
          text: "寄送狀態",
          sortable: true,
          options: this.getOrderStatus,
          tag: true,
        },
        { value: "shippingPrice", text: "運費", sortable: true },
        { value: "amount", text: "總額", sortable: true },
      ];
    },
    getPrizeKeys() {
      let keys = [
        { value: "prizeId", text: "賞品編號", sortable: true },
        { value: "imageUrl", text: "商品", sortable: true, isImage: true },
        { value: "name", text: "商品名稱", sortable: true },
        { value: "createdDate", text: "獲得日期", sortable: true },
        { value: "category", text: "類別", sortable: true },
        { value: "price", text: "金額", sortable: true },
        // { value:'paymentStatus', text:'付款狀態', sortable: true , options: this.getPaymentStatus, tag: true,},
        {
          value: "status",
          text: "是否成立訂單",
          sortable: true,
          options: this.getPrizeStatus,
          tag: true,
        },
        { value: "orderId", text: "訂單編號", sortable: true },
        { value: "weight", text: "體積", sortable: true },
      ];

      // 只有管理員和員工可以編輯體積
      if (this.isAdmin || this.isStaff) {
        keys.push({
          value: "editWeight",
          text: "編輯體積",
          isEvent: true,
          color: this.Theme.ORANGE,
          sortable: false,
        });
      }

      return keys;
    },

    // * 查詢消費紀錄，需有搜尋及分頁，且要顯示查詢區間內總額
    getConsumeKeys() {
      return [
        { value: "productName", text: "商品名稱", sortable: true },
        { value: "name", text: "獎品名稱", sortable: true },
        { value: "category", text: "獎品類別", sortable: true },
        { value: "price", text: "金額", sortable: true },
        { value: "vendorName", text: "廠商", sortable: true },
        { value: "createdDate", text: "時間", sortable: true },
      ];
    },
  },
  methods: {
    ...mapActions([
      "getUserOrderList",
      "saveUserInfo",
      "getUserPrizeList",
      "saveUserPrizeWeight",
      "getUserPrizeLogList",
    ]),
    cancelEvent() {
      this.$emit("cancelEvent");
    },
    async confirmEvent() {
      if (this.tab === 0) {
        // 將 itemDetail 中的 vendorLevel 轉換為數字
        this.itemDetail.vendorLevel = Number(this.itemDetail.vendorLevel);

        const res = await this.saveUserInfo(this.itemDetail);
        const result = res.data;
        if (result.statusCode === 0) {
          this.showAlert({
            title: "提示",
            content: result.message,
            showCancel: false,
            confirmEvent: async () => {
              this.hideAlert();
              this.$emit("confirmEvent");
            },
          });
        } else {
          this.showMessageDialog("提示", result.message);
        }
      } else {
        this.$emit("confirmEvent");
      }
    },
    showMessageDialog(title, content) {
      this.showAlert({
        title: title,
        content: content,
        showCancel: false,
        confirmEvent: async () => {
          this.hideAlert();
        },
      });
    },
    getSelectList(col, option) {
      console.log(`getSelectList === ${option[col.value]}`);
      const find = col.options.find((item) => item.key === option[col.value]);
      if (find) {
        return find.value;
      }
      return "--";
    },
    getSelectColor(col, option) {
      console.log(`getSelectList === ${option[col.value]}`);
      const find = col.options.find((item) => item.key === option[col.value]);
      if (find) {
        return find.color;
      }
      return this.Theme.LIGHT_GRAY;
    },
    changeBirthday(date) {
      console.log(`changeBirthday ${date}`);
    },
    async loadUserOrderData() {
      try {
        this.loading = true;
        const res = await this.getUserOrderList({
          userId: this.itemDetail.userId,
        });

        if (res.data.statusCode === 0) {
          this.list = res.data.data.list;
          this.pagination.totalItems = this.list.length;
          console.log(`getUserOrderList ${JSON.stringify(this.list)}`);
        }
        this.loading = false;
      } catch (e) {
        console.log(`loadUserOrderData error`, e);
        this.loading = false;
      }
    },
    async loadUserPrizeList() {
      try {
        this.loading = true;
        const res = await this.getUserPrizeList({
          userId: this.itemDetail.userId,
          keyword: this.prizeSearchKeyword,
        });
        if (res.data.statusCode === 0) {
          this.prizeList = res.data.data;
          this.pagination.totalItems = this.prizeList.length;
          console.log(`getUserPrizeList ${JSON.stringify(this.list)}`);
        }
        this.loading = false;
      } catch (e) {
        console.log(`loadUserPrizeList error`, e);
        this.loading = false;
      }
    },
    clearPrizeSearch() {
      this.prizeSearchKeyword = "";
      this.loadUserPrizeList();
    },

    // 消費紀錄 > 載入消費數據
    async loadUserConsumeData() {
      try {
        this.loading = true;

        const res = await this.getUserPrizeLogList({
          userId: this.itemDetail.userId,
          pageIndex: this.pagination.page,
          limit: this.pagination.itemsPerPage,
          startDate: this.searchStartDate,
          endDate: this.searchEndDate,
          vendorName: this.searchConsumeItem,
        });

        if (res.data.statusCode === 0) {
          this.list = res.data.data.list;
          // 設定正確的總筆數，從 header 取得
          this.pagination.totalItems = res.data.data.header.totalCount;
          // 使用 API 回傳的總額
          this.totalAmount = res.data.data.header.amount || "0";
          console.log(`getUserPrizeLogList ${JSON.stringify(this.list)}`);
          console.log(`總筆數: ${this.pagination.totalItems}`);
          console.log(`總額: ${this.totalAmount}`);
        }

        console.log(`loadUserConsumeData`, this.list);

        this.loading = false;
      } catch (e) {
        console.log(`loadUserConsumeData error`, e);
        this.loading = false;
      }
    },
    // 消費紀錄 > 分頁切換
    changeConsumePage(page) {
      this.pagination.page = page.page;
      if (page.itemsPerPage === -1) {
        this.pagination.itemsPerPage = 1000;
      } else {
        this.pagination.itemsPerPage = page.itemsPerPage;
      }
      console.log(`changeConsumePage ${JSON.stringify(this.pagination)}`);
      this.loadUserConsumeData();
    },
    // 賞品盒 > 編輯體積 > 點擊編輯體積
    handleCellEvent(event) {
      console.log("cellEvent:", event);
      if (event.key === "editWeight") {
        this.openWeightDialog(event.item);
      }
    },
    // 賞品盒 > 編輯體積 > 開啟編輯體積彈窗
    openWeightDialog(prizeItem) {
      this.editingPrizeId = prizeItem.prizeId;
      this.editingWeight = prizeItem.weight || "";
      this.weightDialog = true;
    },
    // 賞品盒 > 編輯體積 > 確認編輯體積
    async confirmEditWeight() {
      // 驗證輸入
      if (
        !this.editingWeight ||
        isNaN(this.editingWeight) ||
        this.editingWeight <= 0
      ) {
        this.showMessageDialog("錯誤", "請輸入有效的正數");
        return;
      }

      this.weightSaveLoading = true;
      try {
        const res = await this.saveUserPrizeWeight({
          prizeId: this.editingPrizeId,
          weight: parseFloat(this.editingWeight),
        });

        if (res.data.statusCode === 0) {
          this.showMessageDialog("成功", "體積更新成功");
          this.cancelEditWeight();
        } else {
          this.showMessageDialog("錯誤", "體積更新失敗");
        }

        this.showMessageDialog("成功", "體積更新成功");
        this.cancelEditWeight();
      } catch (e) {
        console.log("更新體積失敗:", e);
        this.showMessageDialog("錯誤", "更新體積失敗");
      } finally {
        this.weightSaveLoading = false;
        // 重取賞品列表
        this.loadUserPrizeList();
      }
    },
    cancelEditWeight() {
      this.weightDialog = false;
      this.editingWeight = "";
      this.editingPrizeId = null;
    },
    // 消費紀錄 > 重置搜尋
    resetSearch() {
      this.searchConsumeItem = "";
      this.searchStartDate = "";
      this.searchEndDate = "";
      this.totalAmount = "";
      // 重新載入消費數據
      this.loadUserConsumeData();
    },
  },
};
</script>

<style scoped></style>
